<script setup lang="ts">
import {computed} from "vue";
import dateHelper from "@/core/helpers/dateHelper";
import {BLOCKED_REASON_LABELS} from "@/birthday-gift/constants/palettes";
import {GiftSendHour, VoucherBlockedReason, VoucherStatus} from "@/birthday-gift/interfaces";

const props = defineProps<{
    status: VoucherStatus;
    blockedReason?: VoucherBlockedReason | null;
    sendHour?: GiftSendHour;
    /** When the message actually went out, shown instead of the planned hour. */
    sentAt?: string | null;
}>();

const label = computed(() => {
    switch (props.status) {
    case 'scheduled':
        return `Programmé ${String(props.sendHour ?? 9).padStart(2, '0')}:00`;
    case 'pending_validation':
        return 'À valider';
    case 'blocked':
        return props.blockedReason ? BLOCKED_REASON_LABELS[props.blockedReason] : 'Bloqué';
    case 'excluded':
        return 'Exclu';
    case 'sent':
        return props.sentAt
            ? `Envoyé ${dateHelper.shortFormat(props.sentAt, 'HH:mm')}`
            : 'Envoyé';
    case 'redeemed':
        return 'Remis';
    case 'expired':
        return 'Expiré';
    default:
        return 'Échec';
    }
});

const classes = computed(() => {
    switch (props.status) {
    case 'scheduled':
        return 'bg-primary-lightest text-primary';
    case 'pending_validation':
        return 'bg-lightPurple-lightest text-lightPurple-darkest';
    case 'blocked':
    case 'failed':
        return 'bg-orange-light text-gray-dark';
    case 'sent':
    case 'redeemed':
        return 'bg-secondary text-primary-dark';
    default:
        return 'bg-gray-light text-muted-foreground';
    }
});
</script>

<template>
  <span
    class="inline-flex whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold"
    :class="classes"
  >
    {{ label }}
  </span>
</template>
